import React from 'react'
import { LiveSessionMetadataWithId } from 'sierra-domain/api/private'

export const LiveSessionContext = React.createContext<LiveSessionMetadataWithId | null>(null)
